// extracted by mini-css-extract-plugin
export default {"tableWrapper":"ClientsPage_tableWrapper__ZySz-","oddRow":"ClientsPage_oddRow__XzaDx"};